import ko from "knockout";
import UserModel, { ObservableUserModel } from "models/User";
import authService from "services/authService";
import {
    UsersApi,
    GetUserRequest,
    GetUsersRequest,
    PostUsersSearchRequest,
} from "@genesys/cloud-frontend/apis/UsersApi";

export class UserService {
    /**
     * Observable attribute to track the data for the current user.
     */
    public currentUser: ko.Observable<ObservableUserModel | null> =
        ko.observable(null);

    constructor(principalId: ko.Observable<string | null>) {
        this.syncCurrentUser(principalId());

        /**
         * Keep the current user object synced with the logged in user.
         */
        principalId.subscribe((userId) => {
            this.syncCurrentUser(userId);
        });
    }

    getUsers(
        parameters: GetUsersRequest
    ): Promise<ko.ObservableArray<ObservableUserModel>> {
        const userApi = new UsersApi();
        return userApi.getUsers(parameters).then((response) => {
            const arr =
                response.entities?.map((userData) => new UserModel(userData)) ??
                [];
            return ko.observableArray(arr);
        });
    }

    /**
     * Get a specific user by id.
     */
    getUser(parameters: GetUserRequest): Promise<ObservableUserModel> {
        const userApi = new UsersApi();
        return userApi.getUser(parameters).then((user) => new UserModel(user));
    }

    /**
     * Searches for users that meet the criteria of the query
     */
    searchUsers(
        query: PostUsersSearchRequest
    ): Promise<ko.ObservableArray<ObservableUserModel>> {
        const userApi = new UsersApi();
        return userApi.postUsersSearch(query).then((response) => {
            const arr = response.results.map((user) => new UserModel(user));
            return ko.observableArray(arr);
        });
    }

    private syncCurrentUser(userId: string | null) {
        if (userId) {
            this.getUser({ userId: "me" }).then((user) => {
                this.currentUser(user);
            });
        } else {
            this.currentUser(null);
        }
    }
}

export default new UserService(
    authService.principalId as unknown as ko.Observable<string | null>
);
